var _path, _path2, _circle, _circle2, _circle3, _circle4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeedDial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_2166)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgNoFillOnSidebar svgWhiteStrokeOnSidebar",
    d: "M17.5 14V19M20 16.4769H15",
    stroke: "#0973F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none !important"
    },
    className: "svgNoFillOnSidebar svgWhiteStrokeOnSidebar",
    d: "M23 16.5824C23 13.4993 20.5376 11 17.5 11C14.4624 11 12 13.4993 12 16.5824C12 19.1992 13.7739 21.3955 16.1678 22",
    stroke: "#0973F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svgNoFillOnSidebar svgWhiteStrokeOnSidebar",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.177 18.2744L19.7595 23.4391L21.3924 21.6858L23.6583 20.9072L19.177 18.2744Z",
    stroke: "#00AEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "svgNoFillOnSidebar svgWhiteStrokeOnSidebar",
    cx: 21.5,
    cy: 4.5,
    r: 2.5,
    fill: "#0973F8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "svgNoFillOnSidebar svgWhiteStrokeOnSidebar",
    cx: 15.5,
    cy: 4.5,
    r: 2.5,
    fill: "#0973F8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "svgNoFillOnSidebar svgWhiteStrokeOnSidebar",
    cx: 9.5,
    cy: 4.5,
    r: 2.5,
    fill: "#0973F8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "svgNoFillOnSidebar svgWhiteStrokeOnSidebar",
    cx: 3.5,
    cy: 4.5,
    r: 2.5,
    fill: "#0973F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_2166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedDial);
export default __webpack_public_path__ + "static/media/speedDial.3003d3a5.svg";
export { ForwardRef as ReactComponent };